var map = {
	"./amex.png": 1051,
	"./diners.png": 1052,
	"./discover.png": 1053,
	"./jcb.png": 1054,
	"./maestro.png": 1287,
	"./mastercard.png": 1055,
	"./stripe.png": 1056,
	"./union.png": 1057,
	"./unknown.png": 717,
	"./visa.png": 1058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1286;